<template>
    <div>
        <!-- 顶部导航 -->
        <nav-bar v-if="!type" ref="navBar" :maxOpacity="0.5" bgColor="#000" @watchScroll="watchScroll">
            <div class="nav-box">
                <img class="back" :src="backUrl" @click="goBack">
                <div :style="{color:fontColor}">规则说明</div>
                <div class="back"></div>
            </div>
        </nav-bar>
        <div v-if="!type" :style="`margin-top:calc(10.333vw + ${statusBarHeight}px)`"></div>
        <div class="page-container">
            <div v-for="(item,index) in rule" :key="index" class="rule-page-content">
                <h3>{{ item.title }}</h3>
                <p v-for="(i,o) in item.content" :key="o">{{ i }}</p>
            </div>
            <div class="rule-page-content">
                <h3 class="center">合作方举办方</h3>
                <p class="center">活动指导单位</p>
                <p class="center margin">中国人民银行青岛市中心支行</p>
                <p class="center">活动主办方</p>
                <p class="center">佰业绿色科技（青岛）有限公司</p>
                <p class="center margin">中国邮政储蓄银行青岛分行</p>
                <p class="center">活动赞助单位</p>
                <p class="center">丽达茂</p>
                <p class="center">箜八泰泰国料理</p>
                <p class="center">甄花铁板烧</p>
                <p class="center">梨花安东部队火锅</p>
                <p class="center">烧春秋黑猪肉火锅</p>
                <p class="center">兀岛日式烧肉丼饭</p>
                <p class="center">兆禾日式拉面</p>
                <p class="center">简鹿港式糖水铺</p>
                <p class="center">迷你美珠韩式冰激凌</p>
                <p class="center margin">果燃冰甜品站</p>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from './components/NavBar.vue'
import whiteBack from '../../assets/images/postalNewCustomer/back.png'
import blackBack from '../../assets/images/postalNewCustomer/back_black.png'

export default {
    components: {
        navBar
    },
    data() {
        return {
            fontColor: '#000',
            rule: [
                {
                    title: '一、玩法说明',
                    content: [
                        '第一步：用户在青碳行App端内点击“一键参与”，或在端外输入手机号报名，即可参加活动。',
                        '第二步：邮储银行数字人民币钱包新客报名成功后，可获得数字人民币红包。',
                        '第三步：用户报名成功后，可参与幸运大抽奖。',
                        '第四步：邮储银行数字人民币钱包新客在24小时内开通邮储银行数字人民币钱包，可额外获得6元数字人民币红包奖励。'
                    ]
                },
                {
                    title: '二、活动规则',
                    content: [
                        '1、本次活动时间为2022年10月28日09:00:00-2022年11月18日23:59:59',
                        '2、用户点击“一键参与”即可参与活动，邮储银行数字人民币钱包新客户参与活动，可获得1个数字人民币红包，每位新用户仅限领取1个数字人民币红包，邮储银行数字人民币钱包老客户报名不获得数字人民币红包奖励。',
                        '3、用户报名成功后，可参与幸运大抽奖，通过完成指定任务可获得抽奖次数。',
                        '4、邮储银行数字人民币钱包新客户在24小时内（自红包领取之时开始计算）开立邮储银行数字人民币钱包，可额外获得6元数字人民币红包奖励。',
                        '5、如果领取红包成功后红包并未到账，可能存在延迟情况，请耐心等待；如果红包超过24小时未到账，请拨打青碳行客服电话：0532-55772222，或添加微信：lcago0628联系客服解决。',
                    ]
                },
                {
                    title: '三、奖励规则',
                    content: [
                        '1、邮储银行数字人民币钱包新客户报名活动即可从88.88元、18.88元、8.88元金额中随机获得1份数字人民币红包，每位新客仅限领取1次，红包总计15000个。',
                        '2、邮储新客在24小时内（自红包领取之时开始计算）开立邮储银行数字人民币钱包，可额外领取6元数字人民币红包，限量5000份，先到先得，领完即止。',
                        '3、用户通过完成指定任务，可获得幸运大转盘抽奖次数，奖励从奖池中随机获得，实物奖励需到线下指定地点领取。',
                        '4、数字人民币红包可在2022年11月18日24点前使用。'
                    ]
                },
                {
                    title: '四、免责声明',
                    content: [
                        '1、本次活动最终解释权归主办方所有。',
                        '2、活动相关事宜咨询，请拨打青碳行官方客服热线：0532-55772222。',
                        '3、如果用户以不当方式参与活动，包括但不限于利用系统漏洞、规则漏洞、外挂软件、插件手段或工具套取活动奖励，损害游戏规则，违背活动公平原则，主办方有权取消该用户的参与资格及本次活动奖励获取资格，并且有权冻结相关账号的访问权限。',
                        '4、本次活动与APPLENIC无关。'
                    ]
                },
            ],
            type: '',
            backUrl: blackBack

        }
    },
    computed: {
        statusBarHeight() {
            return this.$store.state.user.statusBarHeight
        },
    },
    created() {
    },
    mounted() {
        if (this.$route.query.type) this.type = this.$route.query.type
    },
    beforeDestroy() {
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        watchScroll(scroll) {
            if (scroll <= 10) {
                this.fontColor = '#000'
                this.backUrl = blackBack
            } else {
                this.fontColor = '#fff'
                this.backUrl = whiteBack
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import "./components/common";
@import "./components/function.scss";
.nav-box {
    width: 100vw;
    padding: 0 pxvw(30);
    display: flex;
    align-items: center;
    justify-content: space-between;
    // color: #fff;
    font-size: pxvw(32);
    height: 10.333vw;
    .back {
        width: pxvw(34);
        height: pxvw(34);
    }
}
.page-container {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;

    .rule-page-content {
        padding: 0 px2rem(40);

        h2 {
            text-align: center;
            margin: px2rem(40) auto 0;
        }

        h3 {
            text-align: left;
            margin-top: px2rem(40);
            margin-bottom: px2rem(20);
        }
        .center {
            text-align: center;
        }

        p {
            margin-bottom: px2rem(20);
            font-size: 16px;
            letter-spacing: 1.5px;
            line-height: 1.5;
            text-align: justify;
            word-break: break-all;

            span {
                color: #1db9b2 !important;
            }
        }
        .margin {
            padding-bottom: px2rem(40);
        }
    }
}
</style>
